import React,{useState,useContext} from 'react'
const ChatInputContext = React.createContext();

export const useChatInputProvider = () => {
    return useContext(ChatInputContext);
}

export const ChatInputProvider = (props) =>{
    const [imageInputDialogStatus, setImageInputDialogStatus] = useState(false);
    const [locationInputDialogStatus, setLocationInputDialogStatus] = useState(false);
    const [audioInputDialogStatus, setAudioInputDialogStatus] = useState(false);
    const value= {
        imageInputDialogStatus,
        setImageInputDialogStatus,
        locationInputDialogStatus,
        setLocationInputDialogStatus,
        audioInputDialogStatus,
        setAudioInputDialogStatus
    }
    return (
        <ChatInputContext.Provider value= {value}>
                {props.children}
        </ChatInputContext.Provider>
    )
}